/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AssetProduct { 
    id: string;
    displayName: string;
    machineNickname: string;
    status?: string;
    organization?: string;
    commonAlarm?: boolean;
    equipmentImageLink?: string;
    geaPUID?: string;
    machineType?: AssetProduct.MachineTypeEnum;
    serialId?: string;
}
export namespace AssetProduct {
    export const MachineTypeEnum = {
        IntegratedDirectDriveSeparator: 'INTEGRATED_DIRECT_DRIVE_SEPARATOR',
        Decanter: 'DECANTER',
        DirectDriveSeparator: 'DIRECT_DRIVE_SEPARATOR',
        FlatBeltSeparator: 'FLAT_BELT_SEPARATOR',
        GearboxSeparator: 'GEARBOX_SEPARATOR',
        CodestrykeSystems: 'CODESTRYKE_SYSTEMS'
    } as const;
    export type MachineTypeEnum = typeof MachineTypeEnum[keyof typeof MachineTypeEnum];
}


